import * as React from 'react'

interface IProps {
  title: string
}

const Title = (props: IProps) => {
  const { title } = props
  return (
    <div className='font-display text-accent w-full text-center mb-4 text-xl dark:text-white sm:text-3xl'>
      <h2>{title}</h2>
    </div>
  )
}

export default Title
